import styled from 'styled-components'
import { variant } from 'styled-system'

import Text from './Text'

// Proxima Nova font weight values only include 900, 700, 600, and 400.
// We will use 400 for regular, 600 (heavy) for semibold, and 700 (black) for bold.

const defaultValues = {
  fontSize: '16px',
  fontFamily: 'Proxima',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px',
  maxWidth: '100%',
  whiteSpace: 'pre-line',
  wordBreak: 'break-word',
}

const P = styled(Text)(props => (
  variant({
    variants: {
      semibold: {
        color: props.theme.colors.grey6,
        lineHeight: '110%',
        fontWeight: 'heavy'
      },
      bold: {
        color: props.theme.colors.grey6,
        lineHeight: '110%',
        fontWeight: 'black'
      }
    }
  })
))

P.defaultProps = {
  as: 'p',
  ...defaultValues
}

export {
  defaultValues,
  P
}
